// En `npm start`, el proxy de CRA (package.json) reenvía a panel.singefin.com:
// rutas relativas = mismo origen → sin CORS. `build` sigue usando URLs absolutas.
const devProxy =
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_DEV_NO_PROXY !== "true";

export const urlApiServer = devProxy
  ? "/api/"
  : process.env.REACT_APP_API_SERVER || "https://panel.singefin.com/api/";

// Rutas tipo /uploads/... del API se resuelven vía el mismo proxy
export const urlApiServerImage = devProxy
  ? ""
  : process.env.REACT_APP_API_SERVER_IMAGE || "https://panel.singefin.com";

// Servicio de correos (no es Strapi). HTTPS directo en producción.
export const mailerUpstreamUrl =
    "https://mailer.geniostecnologicos.com/send-email";

// `npm start`: setupProxy.js → /mailer-send. Build: URL directa salvo override (p. ej. proxy Apache mismo origen).
export const urlMailerSend =
    process.env.REACT_APP_MAILER_URL ||
    (devProxy ? "/mailer-send" : mailerUpstreamUrl);

export const mailerCompanyEmail = "singefincol@gmail.com";

export const mailerWebsiteSingefin = "https://singefin.com/";

/** Plantilla en el mailer (`contact` suele existir; `vinculacion` requiere registrarla en el servidor). */
export const mailerLinkageType = "contact";

/** Guion ASCII (evita rares en algunos backends con multipart + UTF-8). */
export const mailerLinkageSubject =
  "Nueva solicitud de vinculacion - Singefin";
